import {createSlice} from '@reduxjs/toolkit';
import {
    getAdminAccountsSuccess,
    getFreeNewsletterAccountsSuccess,
} from 'src/openapi/admin/apis/GetSystemAccountsApi';

import type {AppState} from 'src/store/typedef';

type InitialState = {
    adminAccountIds: Array<number>,
    freeNewsletterAccountIds: Array<number>,
};

export const initialState: InitialState = {
    adminAccountIds: [],
    freeNewsletterAccountIds: [],
};

export const systemAccountsSlice = createSlice({
    name: 'systemAccounts',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getAdminAccountsSuccess, (state, action) => {
                state.adminAccountIds = action.payload.data.accountsIds;
            })
            .addCase(getFreeNewsletterAccountsSuccess, (state, action) => {
                state.freeNewsletterAccountIds = action.payload.data.accountsIds;
            });
    },
});

export const selectAdminAccountIds: (state: AppState) => number[] = state =>
    state.systemAccounts.adminAccountIds;

export const selectFreeNewsletterAccountIds: (state: AppState) => number[] = state =>
    state.systemAccounts.freeNewsletterAccountIds;
